import { intervalToDuration } from 'date-fns';

export const getEndOfWeekUTC = () => {
  const now = new Date();
  const dayOfWeek = now.getUTCDay();
  const daysToAdd = (7 - dayOfWeek) % 7;

  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + daysToAdd, 23, 59, 59, 999)
  );
};

export const formatTimeLeft = (ms: number, t: (key: string) => string) => {
  const duration = intervalToDuration({ start: 0, end: ms });
  const baseTrKey = 'countdown_to_end_of_week';

  return (
    `${duration.days ?? 0}${t(`${baseTrKey}.day`)} ` +
    `${duration.hours ?? 0}${t(`${baseTrKey}.hour`)} ` +
    `${duration.minutes ?? 0}${t(`${baseTrKey}.minute`)} ` +
    `${duration.seconds ?? 0}${t(`${baseTrKey}.second`)}`
  );
};
